// // src/hooks/klines/adapters/bybitSpot.js
// // Bybit v5 SPOT: REST /v5/market/kline  + WS wss://stream.bybit.com/v5/public/spot
// const PROXY = `${process.env.REACT_APP_BACKEND_URL}/proxy`;
// const API   = "https://api.bybit.com";
// const WS_URL = "wss://stream.bybit.com/v5/public/spot";

// const toLwc = (t,o,h,l,c)=>({ time:t, open:+o, high:+h, low:+l, close:+c });

// // TF маппинг: наш → bybit
// function mapIntervalToBybit(tf) {
//   const m = {
//     "1m":"1","3m":"3","5m":"5","15m":"15","30m":"30",
//     "1h":"60","2h":"120","4h":"240","6h":"360","12h":"720",
//     "1d":"D","1w":"W","30d":"M","1M":"M",
//   };
//   return m[tf] || "1";
// }

// function toSec(ms) { const n=Number(ms); return Math.floor(n/1000); }

// export async function bybitSpotFetchHistory({ symbol, interval="1m", limit=300, start, end }) {
//   const tf = mapIntervalToBybit(interval);
//   const qs = new URLSearchParams();
//   qs.set("category","spot");
//   qs.set("symbol", symbol);           // ex: ETHUSDT
//   qs.set("interval", tf);             // "1" | "5" | "60" | "D" | ...
//   if (start) qs.set("start", String(start));
//   if (end)   qs.set("end",   String(end));
//   if (limit) qs.set("limit", String(limit));   // [1..1000], default 200

//   const url = `${PROXY}/${API}/v5/market/kline?${qs.toString()}`;
//   console.log("[bybitSpot REST] fetch", { symbol, interval, tf, limit, url });

//   const r = await fetch(url, { headers: { 'ngrok-skip-browser-warning': '1' } });
//   if (!r.ok) throw new Error(`Bybit SPOT REST HTTP ${r.status}`);
//   const json = await r.json();

//   // res: { retCode, retMsg, result: { list: [ [start,open,high,low,close,vol,turnover], ... ] } }
//   const rows = json?.result?.list || [];
//   // Bybit возвращает ряды в обратном порядке (новые первыми) — разворачиваем
//   const out = rows
//     .slice()
//     .reverse()
//     .map(a => {
//       const t = toSec(a?.[0]);
//       const o = Number(a?.[1]), h = Number(a?.[2]), l = Number(a?.[3]), c = Number(a?.[4]);
//       if ([t,o,h,l,c].every(Number.isFinite)) return toLwc(t,o,h,l,c);
//       return null;
//     })
//     .filter(Boolean);

//   console.log("[bybitSpot REST] done", {
//     symbol, interval, tf, inCount: rows.length, outCount: out.length,
//     first: out[0], last: out[out.length-1],
//   });
//   return out;
// }

// export function bybitSpotOpenWS({ symbol, interval="1m", onCandle }) {
//   const tf = mapIntervalToBybit(interval);
//   const topic = `kline.${tf}.${symbol}`; // e.g. kline.1.ETHUSDT
//   const ws = new WebSocket(WS_URL);

//   ws.onopen = () => {
//     const sub = { op:"subscribe", args:[topic] };
//     try { ws.send(JSON.stringify(sub)); } catch {}
//     console.log("[bybitSpot WS] open&sub", { topic, sub });
//   };

//   ws.onmessage = (evt) => {
//     try {
//       const msg = JSON.parse(evt.data);
//       // {"topic":"kline.1.ETHUSDT","type":"snapshot","ts":...,"data":[{start,...,open,high,low,close,confirm}]}
//       if (!msg?.topic || !msg?.data) return;
//       if (!String(msg.topic).startsWith("kline")) return;
//       const arr = Array.isArray(msg.data) ? msg.data : [];
//       for (const k of arr) {
//         const t = toSec(k?.start);
//         const o = Number(k?.open), h = Number(k?.high), l = Number(k?.low), c = Number(k?.close);
//         if ([t,o,h,l,c].every(Number.isFinite)) {
//           onCandle?.(toLwc(t,o,h,l,c));
//         }
//       }
//     } catch (e) { /* silent */ }
//   };

//   ws.onerror = (e) => console.warn("[bybitSpot WS] error", e);
//   ws.onclose = () => console.log("[bybitSpot WS] close");

//   return () => { try { ws.close(1000, "bybitSpot ws close"); } catch {} };
// }
/* eslint-disable max-len */
// Bybit v5 SPOT: REST /v5/market/kline  + WS candidates /v5/public/spot

const PROXY = `${process.env.REACT_APP_BACKEND_URL}/proxy`;
const API   = "https://api.bybit.com";

const REGION = String(process.env.REACT_APP_BYBIT_REGION || "").toLowerCase(); // '', 'tr', 'kz', 'georgia'
const WS_CANDIDATES = (() => {
  const core = [
    "wss://stream.bybit.com/v5/public/spot",
    "wss://stream.bybit-aws.com/v5/public/spot",
    "wss://ws.bybit.com/v5/public/spot",
    "wss://stream.bytick.com/v5/public/spot",
  ];
  if (REGION === "tr") core.unshift("wss://stream.bybit-tr.com/v5/public/spot");
  if (REGION === "kz") core.unshift("wss://stream.bybit.kz/v5/public/spot");
  if (REGION === "georgia") core.unshift("wss://stream.bybitgeorgia.ge/v5/public/spot");
  return core;
})();

const toLwc = (t,o,h,l,c)=>({ time:t, open:+o, high:+h, low:+l, close:+c });

function mapIntervalToBybit(tf) {
  const m = {
    "1m":"1","3m":"3","5m":"5","15m":"15","30m":"30",
    "1h":"60","2h":"120","4h":"240","6h":"360","12h":"720",
    "1d":"D","1w":"W","30d":"M","1M":"M",
  };
  return m[tf] || "1";
}

function toSec(ms) { const n=Number(ms); return Math.floor(n/1000); }

async function pickFirstWorkingWs(urls, timeoutMs = 2500) {
  return new Promise((resolve, reject) => {
    let resolved = false;
    const sockets = [];
    const timers = [];

    const finish = (url, keep) => {
      if (resolved) return;
      resolved = true;
      sockets.forEach(s => { try { if (s !== keep) s.close(); } catch{} });
      timers.forEach(t => clearTimeout(t));
      resolve(url);
    };

    urls.forEach(url => {
      try {
        const ws = new WebSocket(url);
        sockets.push(ws);
        ws.onopen = () => finish(url, ws);
        ws.onerror = () => {};
        const t = setTimeout(() => { try { ws.close(); } catch{} }, timeoutMs);
        timers.push(t);
      } catch {}
    });

    setTimeout(() => { if (!resolved) reject(new Error("No Bybit SPOT WS reachable")); }, timeoutMs + 300);
  });
}

export async function bybitSpotFetchHistory({ symbol, interval="1m", limit=300, start, end }) {
  const tf = mapIntervalToBybit(interval);
  const qs = new URLSearchParams();
  qs.set("category","spot");
  qs.set("symbol", symbol);
  qs.set("interval", tf);
  if (start) qs.set("start", String(start));
  if (end)   qs.set("end",   String(end));
  if (limit) qs.set("limit", String(limit));

  const url = `${PROXY}/${API}/v5/market/kline?${qs.toString()}`;
  console.log("[bybitSpot REST] fetch", { symbol, interval, tf, limit, url });

  const r = await fetch(url, { headers: { "ngrok-skip-browser-warning": "1" } });
  if (!r.ok) throw new Error(`Bybit SPOT REST HTTP ${r.status}`);
  const json = await r.json();

  const rows = json?.result?.list || [];
  const out = rows
    .slice()
    .reverse()
    .map(a => {
      const t = toSec(a?.[0]);
      const o = Number(a?.[1]), h = Number(a?.[2]), l = Number(a?.[3]), c = Number(a?.[4]);
      if ([t,o,h,l,c].every(Number.isFinite)) return toLwc(t,o,h,l,c);
      return null;
    })
    .filter(Boolean);

  console.log("[bybitSpot REST] done", {
    symbol, interval, tf, inCount: rows.length, outCount: out.length,
    first: out[0], last: out[out.length-1],
  });
  return out;
}

export async function bybitSpotOpenWS({ symbol, interval="1m", onCandle, wsUrlOverride, pingMs = 20000, onPickedUrl }) {
  const tf = mapIntervalToBybit(interval);
  const topic = `kline.${tf}.${symbol}`;
  const url = wsUrlOverride || await pickFirstWorkingWs(WS_CANDIDATES).catch(() => null);
  if (!url) throw new Error("Bybit SPOT WS not reachable");

  onPickedUrl?.(url);
  const ws = new WebSocket(url);

  ws.onopen = () => {
    const sub = { op:"subscribe", args:[topic] };
    try { ws.send(JSON.stringify(sub)); } catch {}
    try {
      const t = setInterval(() => { try { ws.send(JSON.stringify({ op:"ping" })); } catch{} }, pingMs);
      ws.__pingTimer = t;
    } catch {}
    console.log("[bybitSpot WS] open&sub", { url, topic });
  };

  ws.onmessage = (evt) => {
    try {
      const msg = JSON.parse(evt.data);
      if (!msg?.topic || !msg?.data) return;
      if (!String(msg.topic).startsWith("kline")) return;
      const arr = Array.isArray(msg.data) ? msg.data : [];
      for (const k of arr) {
        const t = toSec(k?.start);
        const o = Number(k?.open), h = Number(k?.high), l = Number(k?.low), c = Number(k?.close);
        if ([t,o,h,l,c].every(Number.isFinite)) onCandle?.(toLwc(t,o,h,l,c));
      }
    } catch {}
  };

  ws.onerror = (e) => console.warn("[bybitSpot WS] error", e);
  ws.onclose = () => {
    if (ws.__pingTimer) { try { clearInterval(ws.__pingTimer); } catch{} }
    console.log("[bybitSpot WS] close");
  };

  return () => { try { if (ws.__pingTimer) clearInterval(ws.__pingTimer); ws.close(1000,"bybitSpot ws close"); } catch {} };
}
